import * as reduxHelper from 'store/utils/reduxHelper';
import SurveysResponses from 'models/SurveysResponses';
import types from './types';

export const initialState = {
  ...reduxHelper.applyReceiveInfo({
    data: { byId: {} },
    errorMessage: '',
  }),
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.SURVEYS_RESPONSE_CREATE_SUCCEEDED: {
      const survey = action.payload;
      const responses = {
        ...state.data.byId,
        [survey.id]: new SurveysResponses(action.payload),
      };

      return reduxHelper.mergeState(
        state,
        reduxHelper.applyReceiveInfo({
          data: {
            ...state.data,
            byId: responses,
          },
        })
      );
    }

    case types.SURVEYS_RESPONSE_CREATE_FAILED:
    case types.SURVEYS_LIST_FAILED:
    default:
      return state;
  }
}
